import React from 'react';
import classes from './Footer.module.scss'
import {withRouter} from "react-router-dom";
import {FormattedMessage} from "react-intl";

const FooterLegal = (props) => {
    return (
        <section className={classes.LegalFooter}>
            <div>
                {/*Copyright &copy; 2020 <a href="https://www.japfacomfeed.co.id" target="_blank" rel="noopener noreferrer">PT Japfa Comfeed Indonesia Tbk.</a> All Rights Reserved.*/}
                <FormattedMessage
                    id={"global.footer.copyright.title"}
                    defaultMessage={"Copyright © 2020 {japfaGroupLink} All Rights Reserved."}
                    values={{
                        japfaGroupLink: <a href="https://www.japfacomfeed.co.id" target="_blank" rel="noopener noreferrer">PT Japfa Food Indonesia.</a>,
                    }}
                />
            </div>
            <div className={classes.LegalPrivacy}>
                <div>
                    <div className={"div-link"} onClick={() => props.history.push('/terms-and-conditions')}>
                        {/*Terms and Conditions*/}
                        <FormattedMessage id={"global.footer.link.title"} defaultMessage={"Terms and Conditions"}/>
                    </div>
                    {/*<div className={"div-link"} onClick={() => props.history.push('/term-of-use')}>Term of Use</div>*/}
                </div>
            </div>
        </section>
    )//end return
}//end of function component

export default withRouter(FooterLegal);